import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
    CREATE_ROLE_SUCCESS,
    FETCH_ROLE_SUCCESS,
    GET_ROLE_SUCCESS,
    REFRESH_ROLE_DATA,
    SAVE_ROLE_QUERY,
    USER_TOKEN_SET
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { setAccessToken } from '../../util/session';
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
    return {
        type: GET_ROLE_SUCCESS,
        data,
        count
    };
};

export const saveResourceQuery = (query) => {
    return {
        type: SAVE_ROLE_QUERY,
        query
    };
};

export const createResourceSuccess = ({ data }) => {
    return {
        type: CREATE_ROLE_SUCCESS,
        data
    };
};

export const fetchResourceSuccess = ({ data }) => {
    return {
        type: FETCH_ROLE_SUCCESS,
        data
    };
};

export const refreshData = () => {
    return {
        type: REFRESH_ROLE_DATA,
    }
};

export const getResource = () => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const { role } = store.getState();
            const { query } = role;
            const response = await axios.get(`/role?${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            dispatch(getResourceSuccess(response.data));
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getResourceForDownload = (columns, filters, name) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const { role } = store.getState();
            const { query } = role;
            const response = await axios.get(`/role/download?columns=${columns}&${generateQueryString(query)}`);
            dispatch(fetchSuccess());
            const str = arrayToCSV(response.data, filters, columns)
            downloadCSV(str, name);
        } catch (error) {
            message.error(error.response.data.message);
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const createResource = (payload) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            // console.log(payload)
            if (payload.role !== 'Org Admin') {
                const response = await axios.post(`/role`, payload);
                dispatch(fetchSuccess());
                dispatch(createResourceSuccess({ data: response.data }));
                history.push('/role');
                dispatch(getResource());
            } else {
                dispatch(fetchSuccess());
                message.error('Invalid Role Name')
            }
        } catch (error) {
            dispatch(fetchError(error));
            console.log("Error****:", error);
        }
    }
};

export const updateResource = (payload, id) => {
    // console.log('payload =>', payload)
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.put(`/role/${id}`, payload);
            setAccessToken(response.data.accessToken);
            dispatch(fetchSuccess());
            dispatch({ type: USER_TOKEN_SET, payload: response.data.accessToken });
            dispatch(getUser());
            history.push('/role');
            dispatch(getResource());
        } catch (error) {
            console.log("Error****:", error);
            dispatch(fetchError(error.response.data.message));
        }
    }
};


export const fetchResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.get(`/role/${id}`);
            dispatch(fetchSuccess());
            dispatch(fetchResourceSuccess({ data: response.data }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const deleteResource = (id) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            await axios.delete(`/role/${id}`);
            dispatch(fetchSuccess());
            dispatch(getResource());
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};

export const getOrgRoles = (orgid) => {
    return async (dispatch) => {

        dispatch(fetchStart());

        try {
            const response = await axios.get(`/role/organisation/${orgid}`);
            dispatch(fetchSuccess());
            dispatch(getResourceSuccess({ data: response.data, count: response.data.length }));
        } catch (error) {
            dispatch(fetchError(error.response.data.message));
            console.log("Error****:", error.response.data.message);
        }
    }
};
